module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "print-no-show",
    attrs: {
      "persistent": "",
      "overflow": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "toolbar--hk",
    attrs: {
      "flat": ""
    }
  }, [_c('img', {
    staticClass: "mx-a",
    attrs: {
      "src": "/static/img/logo-control-inn.png"
    }
  })]), _vm._v(" "), _c('v-list', {
    staticClass: "py-0 list--hk",
    attrs: {
      "dense": ""
    }
  }, [_vm._l((_vm.sidebar), function(item, i) {
    return [_c('v-list-group', {
      key: i,
      attrs: {
        "no-action": ""
      },
      model: {
        value: (item.active),
        callback: function($$v) {
          item.active = $$v
        },
        expression: "item.active"
      }
    }, [(item.resource.data.length > 0) ? _c('v-list-tile', {
      slot: "item"
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": item.pathIcon,
        "alt": item.name,
        "width": "19",
        "height": "19"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1) : _c('v-list-tile', {
      key: i,
      class: {
        'active': ("/" + (_vm.$route.fullPath.split('/')[1])) === item.url
      },
      attrs: {
        "to": item.url
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "src": item.iconUrl,
        "alt": item.description,
        "width": "17",
        "height": "17"
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(item.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1), _vm._v(" "), _vm._l((item.resource.data), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        staticClass: "sidebar-bg",
        class: {
          'active': ("/" + (_vm.$route.fullPath.split('/')[1])) === child.uri
        },
        attrs: {
          "to": {
            name: ("" + (child.uri))
          }
        }
      }, [(child.iconUrl) ? _c('v-list-tile-action', [_c('img', {
        attrs: {
          "src": child.iconUrl,
          "alt": child.description,
          "width": "17",
          "height": "17"
        }
      })]) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n\t\t\t\t\t\t\t\t" + _vm._s(child.name) + "\n\t\t\t\t\t\t\t")])], 1)], 1)
    })], 2)]
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "white toolbar-header toolbar--hk print-no-show",
    attrs: {
      "fixed": "",
      "light": ""
    }
  }, [_c('button', {
    staticClass: "button-drawer ma-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/bars.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "notifications-btn mr-3",
    attrs: {
      "type": "button",
      "id": "buttonNotifications"
    },
    on: {
      "click": _vm.openNotifications
    }
  }, [_c('p', {
    class: {
      'animated bounceIn': _vm.newNotification
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.notificationsQuantity))])]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//picture-controlinn.s3.amazonaws.com/housekeeping/icon-notification.svg",
      "alt": "",
      "height": "22",
      "width": "21"
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notificationsList),
      expression: "notificationsList"
    }],
    staticClass: "notifications-container",
    attrs: {
      "id": "notifications"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "text-xs-left": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Sucursal:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Cliente")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Cod. Reserva:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Tipo de Hab.:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('label', [_vm._v("Fec. de Reserva:")])])], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "notifications-list",
    attrs: {
      "row": "",
      "wrap": "",
      "px-3": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "notifications-list-height",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.notifications), function(notification) {
    return _c('v-flex', {
      key: notification.id,
      staticClass: "notifications-list-border",
      attrs: {
        "xs12": "",
        "text-xs-left": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.hotelName))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.customer))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.code))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(notification.roomName))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": ""
      }
    }, [_c('p', [_vm._v(_vm._s(_vm._f("parseDate")(notification.bookingStart)) + " - " + _vm._s(_vm._f("parseDate")(notification.bookingEnd)))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs2": "",
        "text-xs-right": ""
      }
    }, [_c('v-btn', {
      staticClass: "notifications-actions",
      attrs: {
        "fab": "",
        "dark": "",
        "small": "",
        "error": ""
      },
      on: {
        "click": function($event) {
          _vm.deleteNotification(notification)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "dark": ""
      }
    }, [_vm._v("close")])], 1), _vm._v(" "), _c('v-btn', {
      staticClass: "notifications-actions reservation",
      attrs: {
        "fab": "",
        "dark": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          _vm.selectData(notification)
        }
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tR\n\t\t\t\t\t\t\t\t\t")])], 1)], 1)], 1)
  }))], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/qp-hotels-header.svg",
      "alt": "logo-header-qp"
    }
  })]), _vm._v(" "), _c('v-layout', {
    staticClass: "layout-nav user",
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('div', {
    staticClass: "user-name"
  }, [_c('h6', [_vm._v(_vm._s(_vm.user.fullName))])]), _vm._v(" "), _c('button', {
    staticClass: "user-img my-0",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.user.url_image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('v-menu', {
    staticClass: "pt-1",
    attrs: {
      "offset-y": "",
      "content-class": "menu-layout"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    slot: "activator"
  }, [_c('span', {
    staticClass: "sprite-extra settings"
  })]), _vm._v(" "), _c('v-list', _vm._l((_vm.languages), function(language, indexLang) {
    return _c('v-list-tile', {
      key: language.id,
      class: {
        'active': indexLang === _vm.localLanguage
      },
      on: {
        "click": function($event) {
          _vm.setLanguage(indexLang)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('img', {
      attrs: {
        "src": language.img,
        "alt": language.name
      }
    })]), _vm._v(" "), _c('v-list-tile-title', [_vm._v(_vm._s(language.name))])], 1)
  }))], 1)], 1), _vm._v(" "), _c('button', {
    staticClass: "login-button mr-0",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("power_settings_new")])], 1)], 1), _vm._v(" "), _c('main', {
    staticClass: "print-width"
  }, [
    [_c('div', {
      class: {
        'billing-breadcrumb-style': _vm.$route.path === '/billing/list'
      }
    }, [(_vm.$route.path === '/billing/list') ? _c('div', {
      staticClass: "billing-breadcrumb"
    }, [_c('div', {
      staticClass: "billing-resume"
    }, [_c('div', [_c('p', {
      staticClass: "billing-resume-title"
    }, [_vm._v("INGRESOS")]), _vm._v(" "), _c('p', {
      staticClass: "billing-resume-content"
    }, [_vm._v("$" + _vm._s(_vm._f("round")(_vm.bookingsAmountTotal)))])]), _vm._v(" "), _c('div', [_c('p', {
      staticClass: "billing-resume-title"
    }, [_vm._v("Ocupación Actual")]), _vm._v(" "), _c('p', {
      staticClass: "billing-resume-content"
    }, [_vm._v(_vm._s(_vm.bookingsTotal))])])]), _vm._v(" "), _c('div', {
      staticClass: "billing-vertical-spacer"
    }), _vm._v(" "), _c('v-select', {
      staticClass: "filter-select-billing",
      attrs: {
        "placeholder": "qp Lima",
        "selec": ""
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-breadcrumbs', {
      class: {
        'housemaid-breadcrumb': _vm.$route.name.split('-')[0] === 'housemaids' && _vm.$route.name !== 'housemaids-by-state'
      },
      attrs: {
        "divider": "»"
      }
    }, _vm._l((_vm.$breadcrumbsItems), function(item, itemIndex) {
      return _c('v-breadcrumbs-item', {
        key: itemIndex,
        attrs: {
          "to": item.href,
          "disabled": item.disabled,
          "active-class": 'breadcrumbs__item--active'
        }
      }, [(_vm.firstItem(itemIndex)) ? _c('img', {
        class: {
          'breadcrumb-company-icon': item.href === '/company'
        },
        attrs: {
          "src": (_vm.$imageS3 + "/clerkinn/breadcrumbs/" + (item.id) + "." + (item.extension))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticClass: "ml-1"
      }, [_vm._v(_vm._s(item.text))])])
    }))], 1), _vm._v(" "), (_vm.$route.path === '/billing/list') ? _c('hr', {
      staticClass: "billing-spacer"
    }) : _vm._e()], _vm._v(" "), _c('v-container', {
      attrs: {
        "grid-list-md": "",
        "fluid": ""
      }
    }, [_c('router-view')], 1)
  ], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "300",
      "content-class": "modal-logout"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("¿Está seguro de que desea salir?")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    staticClass: "btn-save mb-2 mr-2",
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "btn-cancel mb-2",
    nativeOn: {
      "click": function($event) {
        _vm.logout($event)
      }
    }
  }, [_vm._v("Salir")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b47556ae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Layout.vue
// module id = 758
// module chunks = 108